import React, { useRef, useEffect, useState, useMemo } from "react";
import { FaHeart, FaComment, FaShare } from "react-icons/fa";
import classes from './ShortView.module.css';
import { Avatar } from "@mui/material";


import { useNavigate } from 'react-router-dom';
// Redux dispatch to dispatch user credentials
import { useSelector } from 'react-redux';
import TVCardVideo from "../TVPage/TVCard/TVCardVideo/TVCardVideo";
import TVCardImage from "../TVPage/TVCard/TVCardImage/TVCardImage";
import TVCardDescription from "../TVPage/TVCard/TVCardDescription/TVCardDescription";
import ShortsInteraction from "./ShortsInteraction/ShortsInteraction"
import ShortsAnimationPlayer from "./ShortsAnimation/ShortsAnimationPlayer";
import { ChevronLeft } from "react-feather";
const ShortsView = ({ posts, onLastPostVisited }) => {
    const [visiblePostId, setVisiblePostId] = useState(null)
    const containerRef = useRef(null);
    const navigate = useNavigate();
    const { userProfileData } = useSelector((state) => state.userProfileSlice);
    const animatorRefs = useRef([]); // for audio animation

    const defaultAudioRef = useRef(null)

    const allowedVideoExtensions = ['.mkv', '.mp4', '.mov'];

    // post data with some extra keys
    const [processedPosts, setProcessedPosts] = useState([]);

    // Handle back button click
    const goBack = () => {
        if (window.history.length > 1) {
            navigate(-1)
        } else {
            navigate('/')

        }
    }
    // Handle Creator Profile Click
    const creatorNameClickHandler = (profileId) => {
        if (profileId === userProfileData.id) {
            navigate(`/userprofile`);
        } else {
            navigate(`/accounts/${profileId}/profile/`);
        }
    };

    // short animation audio
    const playAudio = (reset = false) => {
        if (reset) {
            defaultAudioRef.current.currentTime = 0; // Reset time to start
        }
        defaultAudioRef.current.play();
    };
    const pauseAudio = () => {
        defaultAudioRef.current.pause();
    };

    // For Handling animation ended event for Animation Player
    const handleAnimationEnded = (postId) => {
        if (defaultAudioRef.current) {
            defaultAudioRef.current.pause();  // Stop previous audio
        }
        const postIndex = processedPosts.findIndex(post => post.id === postId);
        if ((processedPosts[postIndex].total_media - 1) > processedPosts[postIndex].current_media_index) {
            // alert('updated')
            processedPosts[postIndex].current_media_index += 1;
            defaultAudioRef.current.currentTime = 0; // Reset time to start
        }
    }
    // helper function for the ui
    const isVideo = (filename) => {
        return allowedVideoExtensions.some(extension => (filename || '').includes(extension));
    }


    useEffect(() => {
        const handleScroll = () => {

            const shortElements = document.querySelectorAll(`.${classes.imgContainer}`);
            shortElements.forEach((shortElement, index) => {
                const rect = shortElement.getBoundingClientRect();
                if (rect.top >= 0 && rect.top <= window.innerHeight / 2) {

                    // video.play();
                    const postId = shortElement.getAttribute('data-short-id');
                    const isLast = shortElement.getAttribute('data-is-last');

                    setVisiblePostId(postId)

                    const postIndex = processedPosts.findIndex(post => post.id === postId);
                    processedPosts[postIndex].current_media_index = 0;


                    if (isLast && onLastPostVisited) {
                        onLastPostVisited()
                    }

                    animatorRefs.current[index].play();
                    if (defaultAudioRef.current) {
                        defaultAudioRef.current.pause();  // Stop previous audio
                        defaultAudioRef.current.currentTime = 0; // Reset time to start
                        defaultAudioRef.current.play().catch(err => console.log("Audio play blocked", err));
                    }

                } else {
                    // video.pause();
                    animatorRefs.current[index].reset();
                }
            });
        };
        // setVisiblePostId(processedPosts[0]?.id);
        const container = containerRef.current;
        container.addEventListener("scrollend", handleScroll);
        return () => container.removeEventListener("scrollend", handleScroll);
    }, []);

    useEffect(() => {
        setProcessedPosts(posts.map(post => ({
            ...post,
            total_media: post.image_field.images.length,
            current_media_index: 0
        })))
    }, [posts])

    return (
        <>
            <div className={classes.shortTopControls}>
                <button className={classes.shortTopControl} onClick={goBack}>
                    <ChevronLeft className={classes.shortTopControlIcon} />
                </button>
            </div>
            <div ref={containerRef} className={classes.shortsContainer}>
                <audio ref={defaultAudioRef} loop classes={classes.audioPlayer} src="/Music/possible.mp3" />
                {processedPosts.map((post, index) => {

                    return (
                        <div key={index} className={classes.shortsCard}>
                            {/* <video className={classes.shortsVideo} src={video} loop muted /> */}
                            <div className={classes.imgContainer} data-short-id={post.id} data-is-last={Number.parseInt(index) === Number.parseInt(processedPosts.length - 1) ? 'true' : undefined}>

                                {
                                    isVideo(post.image_field.images[post.current_media_index])
                                        ? <TVCardVideo isShorts src={post.image_field.images[post.current_media_index]} aspectRatio={post.aspect_ratio} isVisible={post.id === visiblePostId} />
                                        : <ShortsAnimationPlayer onStart={() => playAudio(true)} onStop={pauseAudio} onEnd={() => handleAnimationEnded(post.id)} key={index} ref={(el) => (animatorRefs.current[index] = el)}>
                                            <div className={classes.shortImage}>
                                                <img
                                                    draggable="false"
                                                    src={post.image_field.images[post.current_media_index]}
                                                    alt="PlaceholderImg"
                                                />
                                            </div>
                                        </ShortsAnimationPlayer>
                                }
                            </div>

                            <ShortsInteraction postData={post} />

                            <div className={classes.textContainer}>

                                <div className={classes.infoContainer}>
                                    <div className={classes.creatorInfo}>
                                        <Avatar
                                            src={post.creator.profile_pic}
                                            className={classes.creatorPic}
                                            onClick={() => creatorNameClickHandler(post.creator.id)}
                                            alt="Profile_pic"
                                        />
                                        <h2
                                            className={classes.creatorName}
                                            onClick={() => creatorNameClickHandler(post.creator.id)}
                                        >
                                            {post.creator.name}
                                        </h2>
                                    </div>

                                    <span className={classes.shortDescription} >{post.project_title}</span>
                                    <TVCardDescription className={classes.shortDescription} postData={post} isShorts />
                                </div>
                            </div>

                            <div className={classes.shortsIndexControl}>
                                {
                                    post.image_field.images.length > 1 && post.image_field.images.map((file_url, shortIndex) => (<button key={shortIndex} className={post.current_media_index >= shortIndex ? classes.active : ''} onClick={() => post.current_media_index = shortIndex}></button>))
                                }
                            </div>
                        </div>
                    )
                })}
            </div>
        </>
    );
};

export default ShortsView;
